import axiosInstance from '@/utils/api.js'

var state = {
  timeRange: []
}

var getters = {
  TIME_RANGE: (state) => {
    return state.timeRange
  }
}

var mutations = {
  SET_TIME_RANGE: (state, payload) => {
    state.timeRange = payload
  }
}

var actions = {
  GET_TIME_RANGE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/time_ranges')
    if (result.status === 200) {
      context.commit('SET_TIME_RANGE', result.data)
    }
  },
  CREATE_TIME_RANGE: (context, payload) => {
    return axiosInstance.post('/tariffing/time_ranges', payload)
  },
  UPDATE_TIME_RANGE: (context, payload) => {
    return axiosInstance.put('/tariffing/time_ranges', payload)
  },
  DELETE_TIME_RANGE: (context, payload) => {
    return axiosInstance.delete('/tariffing/time_ranges?timerange_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/timeRange.js